<template>
  <!-- A plain <img> the browser lazy-loads, not v-img: every v-img watches itself
       with an IntersectionObserver of its own, and the browser's cost is per
       observer (a tier list board of 331 cards ran ~660 of them while a card was
       dragged). The parent sizes it. A failed load leaves the box's own background
       showing, as v-img did, not the browser's broken-image icon. -->
  <img
    v-if="!failed"
    :src="src"
    :alt="alt"
    class="brand-image"
    :class="{ 'brand-image--contain': contain }"
    loading="lazy"
    decoding="async"
    @error="failed = true"
  >
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  // The whole image inside the box; otherwise it covers the box.
  contain: Boolean,
})

const failed = ref(false)
watch(() => props.src, () => { failed.value = false })
</script>

<style lang="scss" scoped>
.brand-image {
  display: block;
  object-fit: cover;
}

.brand-image--contain {
  object-fit: contain;
}
</style>
